import DEV_API_URL from './default-dev-apiurl';

// The API the app talks to: --apiurl= (REACT_APP_API_URL) or the dev default. Shared by the
// axios instance and by telemetry, which must not import axios (jest cannot load it as ESM).
export const API_URL: string = process.env.REACT_APP_API_URL || DEV_API_URL;

export const API_BASE_URL = `${API_URL}${API_URL.endsWith('/') ? '' : '/'}`;
